import React from 'react'
import { observer } from 'mobx-react'

import { Drawer, Grid, Pagination } from '@softwaredev_cegeka/stix-core'

import { authenticatedUserStore, notifierStore } from 'src/stores'
import { AuthApi } from 'src/api/authApi'
import { UserSessionTable } from 'src/components/EntityTable'

class UserSessionRoute extends React.Component {
    state = {
        user_sessions: [],
        selectedUserSession: null,
        page: 1,
        totalPages: 1,
        totalElements: 1,
        loading: false,
        params: {},
    }

    authClient = new AuthApi(authenticatedUserStore.authToken)

    componentDidMount() {
        this.fetchAndStoreUserSessions()
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        if (
            prevProps.selectedOrganization !== this.props.selectedOrganization
        ) {
            this.fetchAndStoreUserSessions(1)
        }
    }

    // Cancel still ongoing get requests, to prevent updating state and changing the page to the previous clicked link
    componentWillUnmount() {
        this.authClient.cancelRequest()
    }

    rowSelectHandler = async (selectObj, setDrawerState) => {
        const { selectedRow } = selectObj

        this.setState(
            {
                selectedApplication: selectedRow.original.id,
            },
            () => setDrawerState(true)
        )
    }

    fetchAndStoreUserSessions = (page = this.state.page) => {
        this.setState({ loading: true })
        this.authClient
            .fetchUserSessions(
                page,
                this.props.history,
                this.state.params,
                authenticatedUserStore.selectedOrganization?.id
            )
            .then(response => {
                this.setState({
                    user_sessions: response?.data?.results,
                    totalPages: response?.data?._page.total_pages,
                    totalElements: response?.data?._page.total_elements,
                    loading: false,
                    page: page,
                })
            })
            .catch(err => console.error(err))
    }

    deleteUserSession = userSessionId => {
        this.authClient
            .deleteUserSession(userSessionId)
            .then(response => {
                if (response.status === 200 || response.status === 204) {
                    this.fetchAndStoreUserSessions()
                    notifierStore.setToastInfo(
                        `User session successfully deleted`,
                        true
                    )
                } else {
                    notifierStore.setToastInfo(
                        `Failed to remove the user session`,
                        false
                    )
                }
            })
            .catch(err => {
                notifierStore.setToastInfo(
                    err.response?.data?.error ||
                        'Failed to remove user session',
                    false
                )
            })
            .finally(notifierStore.setShowMessage(true))
    }

    setParams = params => {
        this.setState(
            {
                params: params,
            },
            () => this.fetchAndStoreUserSessions(1)
        )
    }

    handlePageChange = page => {
        this.setState({ page: page }, () => this.fetchAndStoreUserSessions())
    }

    render() {
        return (
            <div className="entity-drawer">
                <Drawer>
                    <Grid.Container>
                        <div className={'page-header'}>
                            <h1 className={'content-title'}>
                                User sessions overview
                            </h1>
                        </div>
                        <Drawer.Context.Consumer>
                            {({ setDrawerState }) => (
                                <div className="data-table-container">
                                    <UserSessionTable
                                        {...this.props}
                                        data={this.state.user_sessions}
                                        loading={this.state.loading}
                                        params={this.state.params}
                                        setParams={this.setParams}
                                        deleteAction={userSessionId =>
                                            this.deleteUserSession(
                                                userSessionId
                                            )
                                        }
                                        rowSelectHandler={selectObj =>
                                            this.rowSelectHandler(
                                                selectObj,
                                                setDrawerState
                                            )
                                        }
                                    />
                                </div>
                            )}
                        </Drawer.Context.Consumer>
                        {this.state.totalPages >= 2 && (
                            <div className="pagination-wrapper">
                                <Pagination
                                    lastPage={this.state.totalPages}
                                    currentPage={this.state.page}
                                    onClick={
                                        this.state.loading
                                            ? () => {}
                                            : this.handlePageChange
                                    }
                                />
                            </div>
                        )}
                    </Grid.Container>
                </Drawer>
            </div>
        )
    }
}

export default observer(UserSessionRoute)
